import { BaseWebComponentElement } from '../../../framework/BaseWebComponentElement';
import { WebAccessControlCustomPagesController } from '../controller/WebAccessControlCustomPagesController';

export class WebAccessControlCustomPagesComponent extends BaseWebComponentElement {
  constructor() {
    super();
    this.initialSetup({
      controllerConstructor: WebAccessControlCustomPagesController,
    });
  }

  static override get observedAttributes(): string[] {
    return [...BaseWebComponentElement.observedAttributes, "data-company-id"];
  }

  override attributeChangedCallback(name: string, oldValue: string, newValue: string): void {
    if (WebAccessControlCustomPagesComponent.observedAttributes.indexOf(name) !== -1) {
      (this.controller as WebAccessControlCustomPagesController)?.render().then().catch();
    }
  }

}
